import { Typography } from "antd";
import styled from "styled-components";

export const StyledTitle = styled(Typography.Text)`
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    flex: 1;
`;
